import { render, staticRenderFns } from "./FeeQuery.vue?vue&type=template&id=3b3f3eb4&scoped=true"
import script from "./FeeQuery.vue?vue&type=script&lang=js"
export * from "./FeeQuery.vue?vue&type=script&lang=js"
import style0 from "./FeeQuery.vue?vue&type=style&index=0&id=3b3f3eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f3eb4",
  null
  
)

export default component.exports